// src/redux/studentSlots/operation.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosStudentInstance from "../../axiosStudentInstance.js";

export const fetchAvailableSlots = createAsyncThunk(
  "studentBookings/fetchAvailableSlots",
  async (filters = {}, thunkAPI) => {
    try {
      const query = {};
      if (filters.teacherId) query.teacherId = filters.teacherId;
      if (filters.country) query.country = filters.country;
      if (filters.city) query.city = filters.city;
      if (filters.instrument) query.instrument = filters.instrument;
      if (filters.date) query.date = filters.date;

      const params = new URLSearchParams(query).toString();
      const endpoint = `/student/available-slots?${params}`;

      const { data } = await axiosStudentInstance.get(endpoint);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

// export const bookSlot = createAsyncThunk(
//   "studentBookings/bookSlot",
//   async (slotId, thunkAPI) => {
//     try {
//       const { data } = await axiosStudentInstance.post("/student/book-slot", {
//         slot_id: slotId,
//       });
//       console.log(data);

//       return data;
//     } catch (err) {
//       return thunkAPI.rejectWithValue(
//         err.response?.data?.message || "Booking error"
//       );
//     }
//   }
// );

//с возможностью пробного урока
export const bookSlot = createAsyncThunk(
  "studentBookings/bookSlot",
  async ({ slotId, isTrial = false }, thunkAPI) => {
    try {
      const { data } = await axiosStudentInstance.post("/student/book-slot", {
        slot_id: slotId,
        is_trial: isTrial || false, // передаём явно
      });

      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Booking error"
      );
    }
  }
);
export const cancelStudentBooking = createAsyncThunk(
  "studentBookings/cancelStudentBooking",
  async (bookingId, thunkAPI) => {
    try {
      const { data } = await axiosStudentInstance.patch(
        `/student/bookings/cancel/${bookingId}`
      );
      return { bookingId, ...data };
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const archiveStudentBooking = createAsyncThunk(
  "studentBookings/archiveBooking",
  async (bookingId, thunkAPI) => {
    try {
      await axiosStudentInstance.patch(`/student/booking/${bookingId}/archive`);
      return bookingId;
    } catch (err) {
      return thunkAPI.rejectWithValue("Error archiving booking", err);
    }
  }
);

export const unarchiveStudentBooking = createAsyncThunk(
  "studentBookings/unarchiveBooking",
  async (bookingId, thunkAPI) => {
    try {
      await axiosStudentInstance.patch(
        `/student/booking/${bookingId}/unarchive`
      );
      return bookingId;
    } catch (err) {
      return thunkAPI.rejectWithValue("Error unarchiving booking", err);
    }
  }
);

export const fetchStudentBookings = createAsyncThunk(
  "studentBookings/fetchStudentBookings",
  async ({ mode = "active", page = 1 }, thunkAPI) => {
    try {
      const { data } = await axiosStudentInstance.get(
        `/student/bookings?mode=${mode}&page=${page}&limit=10`
      );
      return { mode, ...data }; // bookings, total, totalPages, currentPage
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Error fetching bookings"
      );
    }
  }
);
